import { useEffect, useState } from 'react';
import useAuth from './useAuth';
import useCallApiAndLoad from './useCallApiAndLoad';
import { getUnitsAvailable } from '../pages/withdrawal/services/projectService';
import { fetchResponseAdapter } from '../adapters/fetchAdapter';
import { ModelUnit } from '../models/modelUnitModel';

interface Props {
  projectId: string;
}

interface UseUnitListByProjectResult {
  units: ModelUnit[];
  isLoading: boolean;
  error: string | null;
}

const useUnitListByProject = ({
  projectId,
}: Props): UseUnitListByProjectResult => {
  const [units, setUnits] = useState<ModelUnit[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();

  const loadUnitListByProject = async () => {
    setIsLoading(true);
    try {
      const { status, data } = await callEndpoint(
        getUnitsAvailable(projectId, token, true),
      );
      if (status === 200) {
        const unitsResponse = fetchResponseAdapter(data);
        setUnits(unitsResponse.data);
      } else {
        setError('error loading units');
        setUnits([]);
      }
    } catch (e) {
      setError('error loading units');
      setUnits([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadUnitListByProject();
  }, []);

  return {
    units,
    isLoading,
    error,
  };
};

export default useUnitListByProject;
